import { action, observable } from 'mobx';
import { ProjectsStore } from './ProjectsStore';
import { appConfig } from 'cd-eft/config/AppConfig';

class CrossSectionStoreProjectsStore extends ProjectsStore {
    constructor(private crosssectiondesignstore: any) {
        super(crosssectiondesignstore);
    }
}

interface ICrossSectionObject {
    designElementId: number;
    editingStatus: string;
    surfaceDefId: number;
    surveyId: string;
    crossSectionName: string;
    crossSectionId: number;
    crossSectionEntryMethod: string;
    crossSectionAutoGrow: string;
    crossSectionIncreasing: string;
    crossSectionAutoCreated: number;
    beginningX: number;
    beginningY: number;
    surveyCoordinateSystem: number;
    crossSectionPoints: ICrossSectionPoint[];
}

export interface ICrossSectionPoint {
    pointDistance: number;
    distance: number;
    x: number,
    y: number,
    originalElevation: number;
    designElevation: number;
    cutFillHeight: number;
    sectionPoint: number;
}

export class CrossSectionDesignStore {
    constructor(private appStore: any) {
        this.projectsStore = new CrossSectionStoreProjectsStore(this);
        this.init();
    }

    @observable projectsStore: CrossSectionStoreProjectsStore;
    @observable crossSectionObject!: ICrossSectionObject;
    @observable crossSectionPoint!: ICrossSectionPoint;
    @observable chooseCenter: boolean = false; // ?
    @observable summaryTable: any = []; // short list of cross sections
    @observable designElementsDataArray: any = []; // list of cross sections with json data
    @observable designElementsDataMap: any = new Map(); // map of cross sections with json data id: { data }
    @observable selectedCrossSections: any = new Set(); // list of selected cross sections Ids
    @observable displayedCrossSections: any = new Set(); // list of displayed cross sections Ids
    @observable unsavedCrossSections: any = new Set(); // list of unsaved cross sections Ids

    @observable addElementModalOpen: boolean = false;
    @observable crossSectionCopyModalOpen: boolean = false;

    @observable currentElement: any = {};
    @observable currentTab: string = 'Summary'; // ['Summary', 'New', 'Edit']
    @action resetTabs() {
        this.currentTab = 'Summary';
    }

    // Loading and Errors -->
    @observable isLoading: boolean = false;
    @observable error: boolean = false;
    @observable errorMsg: string = '';
    @action.bound setError(msg: string) {
        if (msg !== '') {
            this.error = true;
            this.errorMsg = msg;
            this.isLoading = false;
        } else {
            this.error = false;
            this.errorMsg = '';
            this.isLoading = false;
        }
    }
    // <-- Loading and Errors

    @action reset() {
        this.init();
    }

    @action resetDuplication() {
        this.selectedCrossSections = new Set();
        this.displayedCrossSections = new Set();
        this.unsavedCrossSections = new Set();
    }

    @action resetCurrentObject() {
        this.currentElement = { element: '', name: '', id: '', type: '' };
        this.crossSectionObject = { ...this.initialCrossSectionObject };
        this.resetTabs();
    }

    @action init() {
        this.resetCurrentObject();
        this.resetDuplication();
        this.setError('');
        this.resetTabs();
        this.summaryTable = [];
        this.designElementsDataArray = [];
        this.designElementsDataMap = new Map();
        this.chooseCenter = false;
        this.isLoading = false;
        this.currentTab = 'Summary';
        this.addElementModalOpen = false;
        this.crossSectionCopyModalOpen = false;
    }

    initialCrossSectionPoint: ICrossSectionPoint = {
        pointDistance: 0.0,
        distance: 0.0,
        x: 0.0,
        y: 0.0,
        originalElevation: 0.0,
        designElevation: 0.0,
        cutFillHeight: 0.0,
        sectionPoint: 0,
    };

    initialCrossSectionObject: ICrossSectionObject = {
        designElementId: 0,
        editingStatus: 'add',
        surfaceDefId: 1, // TEMPORARY
        surveyId: '',
        crossSectionName: '',
        crossSectionId: 0,
        crossSectionEntryMethod: 'Coordinates', // 'AngleDistance'
        crossSectionAutoGrow: 'true',
        crossSectionIncreasing: 'true',
        crossSectionAutoCreated: 0,
        beginningX: 0,
        beginningY: 0,
        surveyCoordinateSystem: appConfig.tempHardCodes.wkid,
        crossSectionPoints: [{ ...this.initialCrossSectionPoint }],
    };
}
